const formatWaiverStatus = (status) => {
  if (!status) return "";

  return status
    .replaceAll("_", " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

const formatWaiverType = (type) => {
  switch (type) {
    case "template":
      return "Smart Template";

    case "custom":
      return "Custom Waiver";

    default:
      return type;
  }
};


module.exports = {
  formatWaiverStatus,
  formatWaiverType,
}